// Données complètes pour le site SaDEAP

export const companyInfo = {
  name: "SaDEAP",
  fullName: "SABAHOTH DES EXPLOITATIONS AGROPASTORALE",
  slogan: "Cultivons ensemble un avenir durable",
  email: "contact@sadeap.com",
  phone: "+229 01 97 58 25 09",
  phone2: "+229 01 95 57 81 39",
  phones: ["+229 01 97 58 25 09", "+229 01 95 57 81 39"],
  whatsapp: "+229 95 57 81 39",
  address: "Cotonou, Littoral, Bénin",
  rccm: "COTONOU N° RCCM RB/ABC/20 A 18536",
  socialMedia: {
    facebook: "https://facebook.com/sadeap",
    linkedin: "https://linkedin.com/company/sadeap",
    instagram: "https://instagram.com/sadeap",
  },
};

export const heroData = {
  title: "Cultivons l'Avenir Ensemble",
  subtitle:
    "Agriculture durable et élevage responsable pour un Bénin prospère et une Afrique rayonnante.",
  description:
    "SaDEAP, votre partenaire pour une agriculture moderne, productive et respectueuse de l'environnement.",
  cta: "Découvrir nos produits",
  stats: [
    { value: "20+", label: "Agriculteurs partenaires" },
    { value: "10+", label: "Produits disponibles" },
    { value: "15+", label: "Années d'expérience" },
    { value: "100%", label: "Agriculture durable" },
  ],
};

export const aboutData = {
  mission: {
    title: "Notre Mission",
    content:
      "Promouvoir une agriculture productive et respectueuse de l'environnement, en favorisant l'échange de connaissances, d'expériences et de ressources entre nos équipes et nos partenaires. Nous visons à améliorer les conditions de vie des agriculteurs et des éleveurs, tout en préservant les ressources naturelles pour les générations futures.",
  },
  vision: {
    title: "Notre Vision",
    content:
      "Nous sommes convaincus que l'accès à des aliments sains et de qualité est un droit fondamental. Nous nous efforçons de contribuer à l'amélioration de la santé publique en produisant et en promouvant des aliments nutritifs et sans danger.",
  },
  history: {
    title: "Notre Histoire",
    content:
      "SaDEAP est née d'une passion profonde pour la terre et l'agriculture. Notre histoire est ancrée dans une tradition familiale d'agriculteurs, où la passion pour le monde rural et les joies de cultiver la terre ont été transmises de génération en génération. Inspiré par son héritage, notre fondateur a créé une entreprise agricole qui valorise l'agriculture durable et responsable.",
  },
  values: [
    {
      title: "Durabilité",
      description: "Engagement pour une agriculture durable et responsable",
      icon: "Sprout",
    },
    {
      title: "Solidarité",
      description:
        "Force de la collaboration et de la solidarité entre nos équipes et partenaires",
      icon: "Handshake",
    },
    {
      title: "Innovation",
      description:
        "Recherche constante de solutions pour améliorer nos pratiques",
      icon: "Lightbulb",
    },
    {
      title: "Respect de l'Environnement",
      description:
        "Préservation des ressources naturelles et protection de l'environnement",
      icon: "Globe",
    },
    {
      title: "Santé et Bien-être",
      description:
        "Promotion d'aliments sains et de qualité pour la santé publique",
      icon: "Heart",
    },
  ],
};

export const productsData = {
  categories: [
    {
      id: 1,
      name: "Produits Agricoles",
      icon: "Wheat",
      products: [
        {
          name: "Manioc",
          items: [
            "Manioc frais",
            "Gros tubercules",
            "Récolte à la demande",
            "Vente en gros",
          ],
          image: "/produits/IMG-20260714-WA0095.jpg.jpeg",
          description:
            "Manioc récolté à pleine maturité dans nos plantations. Des tubercules charnus et sains, arrachés le jour de la livraison, destinés aussi bien à la consommation qu'à la transformation en gari, tapioca et farine.",
        },
        {
          name: "Ananas",
          items: [
            "Ananas frais",
            "Cueilli à maturité",
            "Pour table et jus",
            "Vente en gros",
          ],
          image: "/produits/IMG_20260212_184608.jpg.jpeg",
          description:
            "Ananas cueillis à pleine maturité, reconnaissables à leur écorce dorée et à leur chair parfumée. Calibres réguliers, parfaits pour la table comme pour la production de jus.",
        },
        {
          name: "Agrumes",
          items: [
            "Oranges fraîches",
            "Récolte du jour",
            "Sacs filet",
            "Vente en gros",
          ],
          image: "/produits/IMG_20260501_183248.jpg.jpeg",
          description:
            "Oranges récoltées dans nos vergers, conditionnées en sacs filet et acheminées le jour même. Une chaîne courte, du pied de l'arbre au point de vente, qui préserve tout le jus du fruit.",
        },
        {
          name: "Noix de Palme",
          items: [
            "Noix fraîches",
            "Égrappées et triées",
            "Destinées au pressage",
            "Vente en gros",
          ],
          image: "/produits/IMG_20260421_090110.jpg.jpeg",
          description:
            "Noix de palme fraîches, égrappées et triées juste après la coupe des régimes. Riches en huile, elles alimentent notre unité de pressage et sont également disponibles en gros.",
        },
        {
          name: "Noix de Coco",
          items: [
            "Coco vert",
            "Eau de coco",
            "Régime entier",
            "Vente à la pièce",
          ],
          image: "/produits/IMG-20260712-WA0002.jpg.jpeg",
          description:
            "Cocotiers chargés de noix vertes, récoltées à la demande pour garantir la fraîcheur. Eau de coco désaltérante et chair tendre, disponibles en régime entier ou à la pièce.",
        },
        {
          name: "Boutures et Plants",
          items: [
            "Boutures de manioc",
            "Lianes de patate douce",
            "Prêtes à planter",
            "Vente par lot",
          ],
          image: "/produits/IMG_20260630_123555.jpg.jpeg",
          description:
            "Boutures de manioc et lianes de patate douce sélectionnées sur nos propres parcelles. Coupées et mises à disposition le jour même pour assurer la meilleure reprise possible.",
        },
      ],
    },
    {
      id: 2,
      name: "Produits d'Élevage",
      icon: "Beef",
      products: [
        {
          name: "Lapins de Chair",
          items: [
            "Race blanche",
            "Nourri au fourrage vert",
            "Livré vivant",
            "Suivi sanitaire",
          ],
          image: "/produits/IMG_20251231_102326.jpg.jpeg",
          description:
            "Lapins de race blanche élevés dans nos clapiers, nourris au fourrage vert et suivis sur le plan sanitaire de la naissance au sevrage. Une viande blanche, maigre et tendre.",
        },
        {
          name: "Lapereaux et Reproducteurs",
          items: [
            "Lapereaux sevrés",
            "Couples reproducteurs",
            "Portées suivies",
            "Conseil d'élevage",
          ],
          image: "/produits/IMG-20260714-WA0097.jpg.jpeg",
          description:
            "Lapereaux issus de nos propres portées, élevés en clapier sur nid garni. Cédés sevrés ou en couples reproducteurs, avec nos conseils pour démarrer votre élevage cunicole.",
        },
        {
          name: "Volaille Locale",
          items: [
            "Poulet local",
            "Élevé en liberté",
            "Poulettes",
            "Vente à l'unité",
          ],
          image: "/produits/IMG_20260128_094644.jpg.jpeg",
          description:
            "Poulets de race locale élevés en liberté dans la ferme, complétant leur ration au picorage. Une chair ferme et goûteuse, très recherchée sur les marchés béninois.",
        },
      ],
    },
    {
      id: 3,
      name: "Produits Transformés",
      icon: "Factory",
      products: [
        {
          name: "Gari",
          items: [
            "Gari blanc",
            "Torréfié au feu de bois",
            "Tamisé à la main",
            "Vente en gros",
          ],
          image: "/produits/IMG_20260707_123209.jpg.jpeg",
          description:
            "Gari produit entièrement sur place : manioc râpé, pressé, puis torréfié au feu de bois dans nos bassines. Un grain sec, blanc et régulier, tamisé à la main avant ensachage.",
        },
        {
          name: "Tapioca et Farine de Manioc",
          items: ["Tapioca", "Farine de manioc", "Sans additif", "Vente en gros"],
          image: "/produits/IMG_20260215_154117.jpg.jpeg",
          description:
            "Pâte de manioc pressée et essorée dans nos paniers de rouissage, puis séchée et moulue. La base de notre tapioca et de notre farine de manioc, sans aucun additif.",
        },
        {
          name: "Huile de Palme",
          items: [
            "Huile rouge",
            "Extraction artisanale",
            "Noix séchées au soleil",
            "Bidons sur demande",
          ],
          image: "/produits/IMG_20260421_090136.jpg.jpeg",
          description:
            "Noix de palme séchées au soleil avant pressage, l'étape clé de notre huile rouge artisanale. Une huile dense et parfumée, extraite sans solvant ni raffinage.",
        },
      ],
    },
    {
      id: 4,
      name: "Équipements et Intrants",
      icon: "Tractor",
      bio: false,
      products: [
        {
          name: "Pulvérisateur Motorisé",
          items: [
            "Moteur essence 7,5 CV",
            "Réservoir 15 L",
            "Tuyau et lance fournis",
            "Neuf sous emballage",
          ],
          image: "/produits/IMG_20251215_225755.jpg.jpeg",
          description:
            "Pulvérisateur thermique sur châssis brancard, équipé d'un moteur essence 7,5 CV et d'une pompe à pistons. Livré complet : tuyau haute pression, lance de pulvérisation, crépine d'aspiration et jeu d'accessoires, neuf dans son emballage d'origine.",
        },
        {
          name: "Presse Hydraulique",
          items: [
            "Vérin hydraulique",
            "Cage inox perforée",
            "Châssis renforcé",
            "Fabrication atelier",
          ],
          image: "/produits/IMG_20260505_113017.jpg.jpeg",
          description:
            "Presse hydraulique à vérin montée sur châssis métallique renforcé, avec cage inox perforée et bac de récupération. Fabriquée dans notre atelier pour l'essorage du manioc râpé et le pressage de la pulpe de palme.",
        },
        {
          name: "4Tree Efficiency Enhancer",
          items: [
            "Sachet 5 g = 40 doses",
            "Formule ionique",
            "Riz, maïs, manioc, palmier",
            "Produit de Thaïlande",
          ],
          image: "/produits/IMG_20260119_170056.jpg.jpeg",
          description:
            "Activateur de croissance à formule ionique importé de Thaïlande. Un sachet de 5 g contient 40 doses : une cuillère diluée dans 20 L d'eau traite environ 3 hectares de riz, maïs ou manioc, à renouveler tous les 10 à 15 jours au pulvérisateur.",
        },
      ],
    },
  ],
};

export const servicesData = [
  {
    id: 1,
    title: "Gestion des Fermes Agropastorales",
    tagline: "Votre exploitation entre de bonnes mains",
    description:
      "Nous prenons en charge votre exploitation agropastorale de A à Z : planification des cultures et de l'élevage, conduite quotidienne des travaux et suivi des résultats. Vous gardez la maîtrise de votre ferme, nous en assurons la performance.",
    icon: "Warehouse",
    features: [
      "Gestion opérationnelle quotidienne",
      "Planification des cultures et de l'élevage",
      "Suivi sanitaire des animaux et des cultures",
      "Optimisation des ressources et des intrants",
      "Reporting et tableaux de bord réguliers",
      "Encadrement du personnel de ferme",
    ],
    highlights: [
      "Interlocuteur unique",
      "Suivi mensuel",
      "Objectifs de rendement",
      "Transparence totale",
    ],
    image: "/produits/IMG_20260618_100123.jpg.jpeg",
  },
  {
    id: 2,
    title: "Conseil et Accompagnement",
    tagline: "L'expertise terrain à vos côtés",
    description:
      "Agriculteurs et éleveurs, nous vous accompagnons à chaque étape : diagnostic de votre exploitation, choix des cultures et des races, itinéraires techniques et suivi sur le terrain. Un appui concret, nourri par notre propre expérience de production.",
    icon: "UserCog",
    features: [
      "Diagnostic complet de l'exploitation",
      "Plan de développement personnalisé",
      "Itinéraires techniques adaptés",
      "Visites et suivi sur le terrain",
    ],
    highlights: [
      "Conseil de proximité",
      "Expérience de producteur",
      "Solutions concrètes",
      "Suivi dans la durée",
    ],
    image: "/produits/IMG-20260714-WA0100.jpg.jpeg",
  },
  {
    id: 3,
    title: "Formation et Capacitation",
    tagline: "Transmettre pour faire grandir",
    description:
      "Nous partageons notre savoir-faire à travers des formations pratiques sur nos parcelles et dans nos ateliers : techniques de culture, conduite d'élevage, transformation et bon usage des intrants. Des sessions concrètes, pensées pour être appliquées dès le lendemain.",
    icon: "GraduationCap",
    features: [
      "Techniques agricoles modernes",
      "Conduite d'élevage cunicole et avicole",
      "Transformation (gari, huile, tapioca)",
      "Bon usage des intrants et équipements",
    ],
    highlights: [
      "Formations pratiques",
      "Directement sur le terrain",
      "Supports fournis",
      "Groupes encadrés",
    ],
    image: "/produits/IMG_20260119_170133.jpg.jpeg",
  },
  {
    id: 4,
    title: "Location de Matériel Agricole",
    tagline: "Le bon équipement au bon moment",
    description:
      "Accédez à du matériel professionnel sans en supporter le coût d'achat. Nous mettons à disposition pulvérisateurs motorisés, presses hydrauliques et équipements de transformation, entretenus et prêts à l'emploi, avec une prise en main assurée par nos équipes.",
    icon: "Tractor",
    features: [
      "Pulvérisateur motorisé (thermique)",
      "Presse hydraulique de transformation",
      "Matériel entretenu et fiable",
      "Prise en main et conseils inclus",
    ],
    highlights: [
      "Sans investissement",
      "Matériel entretenu",
      "Disponible rapidement",
      "Accompagnement à l'usage",
    ],
    image: "/produits/IMG_20251215_225755.jpg.jpeg",
  },
  {
    id: 5,
    title: "Vente de Semences et Intrants",
    tagline: "Bien démarrer, mieux produire",
    description:
      "Nous fournissons du matériel végétal sélectionné sur nos propres parcelles — boutures de manioc et lianes de patate douce — ainsi que des intrants performants comme l'activateur de croissance 4Tree. De quoi lancer vos cultures sur des bases saines et productives.",
    icon: "Sprout",
    features: [
      "Boutures de manioc sélectionnées",
      "Lianes de patate douce",
      "Activateur de croissance 4Tree",
      "Conseil d'application personnalisé",
    ],
    highlights: [
      "Matériel de nos parcelles",
      "Sélectionné pour la reprise",
      "Vente par lot",
      "Conseil d'application",
    ],
    image: "/produits/IMG_20260630_123555.jpg.jpeg",
  },
  {
    id: 6,
    title: "Transport et Stockage",
    tagline: "De la parcelle au point de vente",
    description:
      "Nous organisons l'acheminement et la conservation de vos récoltes pour préserver leur fraîcheur et leur valeur. Récolte groupée, mise en lots et livraison le jour même : une chaîne courte qui limite les pertes après récolte.",
    icon: "Truck",
    features: [
      "Récolte groupée et mise en lots",
      "Conservation avant expédition",
      "Livraison en circuit court",
      "Réduction des pertes après récolte",
    ],
    highlights: [
      "Circuit court",
      "Livraison rapide",
      "Moins de pertes",
      "Produits préservés",
    ],
    image: "/produits/IMG_20260120_170641.jpg.jpeg",
  },
  {
    id: 7,
    title: "Innovation et Développement",
    tagline: "Fabriquer nos propres solutions",
    description:
      "Nous concevons et fabriquons dans notre atelier une partie de notre matériel — comme nos presses hydrauliques — et testons de nouvelles techniques et intrants pour gagner en productivité. L'innovation au service d'une agriculture plus efficace et plus durable.",
    icon: "FlaskConical",
    features: [
      "Conception et fabrication d'équipements",
      "Test de nouveaux intrants",
      "Amélioration continue des procédés",
      "Solutions durables et locales",
    ],
    highlights: [
      "Fabrication locale",
      "Procédés éprouvés",
      "Gain de productivité",
      "Approche durable",
    ],
    image: "/produits/IMG_20260219_122308.jpg.jpeg",
  },
];

export const galleryData = {
  images: [
    {
      id: 1,
      url: "/produits/IMG_20260120_170641.jpg.jpeg",
      title: "Récolte de manioc mise en tas au champ",
      category: "agriculture",
    },
    {
      id: 2,
      url: "/produits/IMG-20260714-WA0096.jpg.jpeg",
      title: "Un tubercule de manioc hors norme",
      category: "agriculture",
    },
    {
      id: 3,
      url: "/produits/IMG_20260630_123519.jpg.jpeg",
      title: "Plantation des boutures après labour",
      category: "agriculture",
    },
    {
      id: 4,
      url: "/produits/IMG_20260630_123621.jpg.jpeg",
      title: "Mise en terre des lianes de patate douce",
      category: "agriculture",
    },
    {
      id: 5,
      url: "/produits/IMG_20260421_090149.jpg.jpeg",
      title: "Régimes de palme fraîchement coupés",
      category: "agriculture",
    },
    {
      id: 6,
      url: "/produits/IMG_20260618_100123.jpg.jpeg",
      title: "Palmier à huile entretenu en plantation",
      category: "agriculture",
    },
    {
      id: 7,
      url: "/produits/IMG_20260620_145513.jpg.jpeg",
      title: "Notre unité de transformation du manioc",
      category: "transformation",
    },
    {
      id: 8,
      url: "/produits/IMG_20260707_123207.jpg.jpeg",
      title: "Torréfaction du gari au feu de bois",
      category: "transformation",
    },
    {
      id: 9,
      url: "/produits/IMG-20260714-WA0100.jpg.jpeg",
      title: "Fierté de la récolte",
      category: "equipe",
    },
    {
      id: 10,
      url: "/produits/IMG_20260219_122308.jpg.jpeg",
      title: "Fabrication de la presse dans notre atelier",
      category: "equipement",
    },
    {
      id: 11,
      url: "/produits/IMG_20251215_224252.jpg.jpeg",
      title: "Réception d'un pulvérisateur motorisé",
      category: "equipement",
    },
    {
      id: 12,
      url: "/produits/IMG_20251215_224337.jpg.jpeg",
      title: "Déballage : moteur et tuyau haute pression",
      category: "equipement",
    },
    {
      id: 13,
      url: "/produits/IMG_20251215_224416.jpg.jpeg",
      title: "Pulvérisateur monté et prêt à l'emploi",
      category: "equipement",
    },
    {
      id: 14,
      url: "/produits/IMG_20251215_224446.jpg.jpeg",
      title: "Lance, crépine et accessoires fournis",
      category: "equipement",
    },
    {
      id: 15,
      url: "/produits/IMG_20251215_223942.jpg.jpeg",
      title: "Colis préparé pour expédition",
      category: "equipement",
    },
    {
      id: 16,
      url: "/produits/IMG_20260119_170133.jpg.jpeg",
      title: "Guide d'application du 4Tree Efficiency Enhancer",
      category: "equipement",
    },
  ],
  videos: [
    {
      id: 1,
      url: "/videos/video.mp4",
      title: "SaDEAP en action",
      thumbnail: "/produits/IMG_20260620_145513.jpg.jpeg",
    },
    {
      id: 2,
      url: "/videos/VID_20260612_121600.mp4",
      title: "Sur nos parcelles",
      thumbnail: "/produits/IMG_20260618_100123.jpg.jpeg",
    },
  ],
};

export const partnersData = [
  {
    id: 1,
    name: "Ministère de l'Agriculture",
    logo: "https://via.placeholder.com/200x100/1B5E3F/FFFFFF?text=MAEP",
    type: "Institutionnel",
  },
  {
    id: 2,
    name: "FUPRO Bénin",
    logo: "https://via.placeholder.com/200x100/7CB342/FFFFFF?text=FUPRO",
    type: "Organisation",
  },
  {
    id: 3,
    name: "Banque Agricole",
    logo: "https://via.placeholder.com/200x100/E6C847/333333?text=BA",
    type: "Financier",
  },
  {
    id: 4,
    name: "FAO Bénin",
    logo: "https://via.placeholder.com/200x100/1B5E3F/FFFFFF?text=FAO",
    type: "International",
  },
];

export const testimonialsData = [
  {
    id: 1,
    name: "Jean-Baptiste HOUNKPE",
    role: "Agriculteur partenaire",
    content:
      "Grâce à SaDEAP, j'ai pu moderniser mon exploitation et augmenter ma production de 40%. Leur accompagnement est exceptionnel.",
    
  },
  {
    id: 2,
    name: "Marie AGOSSOU",
    role: "Éleveuse de volaille",
    content:
      "Les formations et le suivi de SaDEAP m'ont permis de professionnaliser mon élevage. Je recommande vivement leurs services.",

  },
  {
    id: 3,
    name: "Paul MENSAH",
    role: "Producteur de fruits",
    content:
      "L'entreprise nous offre un débouché stable pour nos produits. C'est un vrai partenaire de développement.",
 
  },
];

export const blogData = [
  {
    id: 1,
    title: "Les avantages de l'agriculture biologique au Bénin",
    excerpt:
      "Découvrez pourquoi de plus en plus d'agriculteurs béninois adoptent des pratiques biologiques.",
    date: "15 Mars 2024",
    author: "Équipe SaDEAP",
    image: "https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=800",
    category: "Agriculture",
  },
  {
    id: 2,
    title: "Guide complet de l'élevage de poulets locaux",
    excerpt:
      "Tout ce que vous devez savoir pour réussir votre élevage de poulets locaux.",
    date: "10 Mars 2024",
    author: "Dr. AHOTON",
    image: "https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=800",
    category: "Élevage",
  },
  {
    id: 3,
    title: "Innovation : La transformation locale des produits agricoles",
    excerpt:
      "Comment créer de la valeur ajoutée en transformant vos produits agricoles.",
    date: "5 Mars 2024",
    author: "Équipe Innovation",
    image: "https://images.unsplash.com/photo-1606924735276-fbb5b325e933?w=800",
    category: "Transformation",
  },
];

export const navigationLinks = [
  { name: "Accueil", path: "/" },
  { name: "À propos", path: "/about" },
  { name: "Produits", path: "/products" },
  { name: "Services", path: "/services" },
  { name: "Galerie", path: "/gallery" },
  { name: "Contact", path: "/contact" },
];
